"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiListView16 = {
    paths: [
        {
            path: 'M14.5,12 L14.5,14 L0.5,14 L0.5,12 L14.5,12 Z M14.5,8 L14.5,10 L0.5,10 L0.5,8 L14.5,8 Z M14.5,4 L14.5,6 L0.5,6 L0.5,4 L14.5,4 Z M14.5,0 L14.5,2 L0.5,2 L0.5,0 L14.5,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'List View',
    width: 15,
    height: 14,
};
// Only size '16' icon was given by UX
var muiListView = {
    base: muiListView16,
    smIcon: muiListView16,
    lgIcon: muiListView16,
};
exports.muiListView = muiListView;
//# sourceMappingURL=listView.js.map